module.exports = __webpack_public_path__ + "img/logo-font.cf255ed4.png";